import { render, staticRenderFns } from "./screen-inspection.vue?vue&type=template&id=41c16123&scoped=true"
import script from "./screen-inspection.vue?vue&type=script&lang=js"
export * from "./screen-inspection.vue?vue&type=script&lang=js"
import style0 from "./screen-inspection.vue?vue&type=style&index=0&id=41c16123&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c16123",
  null
  
)

export default component.exports